import React, { useEffect, useState } from 'react';
import { Button, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import PageWrapper from 'components/Common/PageWraper';
import PageHeader from 'components/Header/Page';
import EditorForm from 'components/Common/EditorForm/EditorForm';
import InsightsSection from 'components/Common/InsightsSection';
import { addOrUpdateInsights, deleteInsights, getInsights } from 'service/service';

const sampleInsights = [
  {
    insightId: 134,
    title: 'Demo',
    description: '<p>Demo Description</p>',
    opsType: 'Incidents Summary',
    createdBy: 'svcedappepwise@pepsico.com',
    updatedBy: null,
    createdDate: '2026-05-07T03:43:45.140Z',
    updatedDate: '2026-05-07T03:43:45.140Z',
    technology: 'SAP BW',
    month: '2026-04',
  },
  {
    insightId: 135,
    title: 'SAP BW',
    description:
      '<p>1 P3 incidents due to Data Quality issue (Delimiter Issue).</p><p>Permanent resolution is in progress.</p>',
    opsType: 'Incidents Summary',
    createdBy: 'svcedappepwise@pepsico.com',
    updatedBy: null,
    createdDate: '2026-05-07T04:10:20.250Z',
    updatedDate: '2026-05-07T04:10:20.250Z',
    technology: 'SAP BW',
    month: '2026-04',
  },
];

export default function RichTextEditorPage() {
    const navigate = useNavigate();
    const [insights, setInsights] = useState(sampleInsights);
    const [loader, setLoader] = useState<boolean>(false);
    const fetchInsights = async (selectedMonth: string) => {
            setLoader(true);
            try {
                const response = await getInsights('Incidents Summary', '', '2026-04');
                if (response.success) { setInsights(response.data.data); }
            } catch (error) {
                console.error('Failed to get insights:', error);
            } finally {
                setLoader(false);
            }
        };
        const handleAddInsight = async (newInsight: any) => {
            try {
                setLoader(true);
                const response = await addOrUpdateInsights({ title: newInsight?.title, xopsType: 'Incidents Summary', description: newInsight?.description, month: '2026-04' });
                if (response.success) {
                    fetchInsights('2026-04');
                }
            } catch (error) {
                console.error('Failed to add insight:', error);
            } finally {
                setLoader(false);
            }
        };
        const handleUpdateInsight = async (updatedInsight: any) => {
            try {
                setLoader(true);
                const response = await addOrUpdateInsights({ title: updatedInsight?.title, xopsType: 'Incidents Summary', description: updatedInsight?.description, insight_id: updatedInsight?.id, month: '2026-04' });
                if (response.success) {
                    fetchInsights('2026-04');
                }
            } catch (error) {
                console.error('Failed to update insight:', error);
            } finally {
                setLoader(false);
            }
        };
        const handleDeleteInsight = async (insightId: number) => {
            try {
                setLoader(true);
                const response = await deleteInsights(insightId);
                if (response.success) {
                    fetchInsights('2026-04');
                }
            } catch (error) {
                console.error('Failed to delete insight:', error);
            } finally {
                setLoader(false);
            }
        };
        useEffect(() => {
            fetchInsights('2026-04');
        }, []);

    return (
        <PageWrapper>
            <PageHeader title="Rich Text Editor Demo">
                <Button variant="pepwiseSecondary" onClick={() => navigate(-1)}>
                    ← Back
                </Button>
            </PageHeader>

            <Grid container spacing={4} sx={{ mt: 3, px: 2, display: 'flex', justifyContent: 'center' }}>
                <Grid item xs={12} md={10}>
                    <InsightsSection
                        insights={insights}
                        onAdd={handleAddInsight}
                        onUpdate={handleUpdateInsight}
                        onDelete={handleDeleteInsight}
                    />
                </Grid>
            </Grid>
        </PageWrapper>
    );
}
